module.exports = __webpack_public_path__ + "1286d853de689b89678841f7ab0724d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-background.png
// module id = 392
// module chunks = 0